export default "__VITE_ASSET__CH0SoVEZ__"